import React, { createContext, useEffect, useState } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { SetupPayment } from './setup-payment';
import { StripeContext } from '../StripeContext';
import { usePaymentApiV1 } from '../../../../clients/quipli-service/payment/payment-api-v1';
import { StripeCard } from '../../../../clients/quipli-service/payment/payment';

createContext(StripeContext);
export default function StripeSetupInit({
  userId,
  type,
  userCard,
  close,
  setCard,
}: {
  userId: number;
  type: 'bankAccount' | 'cardPresent' | 'card';
  userCard?: StripeCard;
  close?: () => void;
  setCard?: (stripeCard: StripeCard) => void;
}) {
  const { getStripeSettingsAdmin } = usePaymentApiV1();

  const [stripe, setStripe] = useState<Promise<Stripe | null>>(
    Promise.resolve().then(() => {
      return null;
    }),
  );

  useEffect(() => {
    getStripeSettingsAdmin().then((settings) => {
      setStripe(
        loadStripe(settings.publishableKey, {
          stripeAccount: settings.accountType !== 'custom' ? settings.connectedAccountId : undefined,
        }),
      );
    });
  }, []);

  return (
    <StripeContext.Provider value={stripe}>
      <SetupPayment userId={userId} close={close} userCard={userCard} setCard={setCard} type={type} />
    </StripeContext.Provider>
  );
}
